import { useState, useEffect } from 'react';

import { Stack, styled } from '@mui/material';
import { AnimatePresence } from 'framer-motion';

import JamieChiefOfStaff from '@/components/AskMeAnything/components/jamieReply/JamieChiefOfStaff';
import Markdown from '@/utils/Markdown';

import Thinking from './Thinking';
import Thoughts from './Thoughts';

const RepleyWrapper = styled(Stack)({
  marginTop: '8px',
  fontSize: '13px',
  flexWrap: 'wrap',
  userSelect: 'text'
});

interface JamieReplyProps {
  response: string;
  thoughts: string[];
  isStreamingThoughts: boolean;
}

const JamieReply = ({ response, thoughts, isStreamingThoughts }: JamieReplyProps) => {
  const [showThoughts, setShowThoughts] = useState(false);

  useEffect(() => {
    if (response) {
      setShowThoughts(false);
    }
  }, [response]);

  useEffect(() => {
    if (isStreamingThoughts) {
      setShowThoughts(true);
    }
  }, [isStreamingThoughts]);

  return (
    <Stack padding={'16px 0'}>
      <JamieChiefOfStaff />
      <RepleyWrapper>
        <AnimatePresence mode="wait">{!response && <Thinking />}</AnimatePresence>
        <AnimatePresence mode="wait">
          {showThoughts && <Thoughts thoughts={thoughts} />}
        </AnimatePresence>
        <Markdown>{response}</Markdown>
      </RepleyWrapper>
    </Stack>
  );
};

export default JamieReply;
